import {useContext} from 'react';
import {AuthContext} from './AuthProvider';

const useIsLoggedIn = () => {
  const {isLoggedIn, isLoading, setIsLoggedIn, checkAuth, setSessionManuallyInitialized} = useContext(AuthContext);
  return {isLoggedIn, isLoading, setIsLoggedIn, checkAuth, setSessionManuallyInitialized};
};

export default useIsLoggedIn;
